import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../../ui-components/Image/Image';
import { P3 } from '../../ui-components/P3/P3';
import styles from './EbikePage.module.css';

const EbikeTrailerPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.ebikeTextList}>
      <h4 className={styles.ebikeTextTitle}>{t('ebikeTrailer.title')}</h4>
      <P3>{t('ebikeTrailer.content1.text1')}</P3>
      <P3>{t('ebikeTrailer.content1.text2')}</P3>
      <p className="h8">{t('ebikeTrailer.content2.title')}</p>
      <P3>{t('ebikeTrailer.content2.text')}</P3>
      <p className="h8">{t('ebikeTrailer.content3.title')}</p>
      <P3>{t('ebikeTrailer.content3.text1')}</P3>
      <P3>{t('ebikeTrailer.content3.text2')}</P3>
      <P3>{t('ebikeTrailer.content3.text3')}</P3>
      <P3>{t('ebikeTrailer.content3.text4')}</P3>
      <div className={styles.ebikeImgBox}>
        <Image src="/content/ebike/trailer.jpg" />
      </div>
    </div>
  );
};

export default EbikeTrailerPage;
